import { faQuestion } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Helmet } from 'react-helmet-async'
import splash from '../../media/classroomSplash.jpg'
import QuoteIcon from '../../media/icon-science.svg?react'
import oftmcssLogo from '../../media/maricopa-footer-logo.svg'
import { Brand, Content, Templates } from 'ui'
import * as Forms from './Forms'
import { randomTestimonial } from './testimonials'

/**
 * The initial step for creating an account as a teacher.
 */
export const ResetPasswordView: React.FC = () => {
  const testimonial = randomTestimonial()
  return (
    <Templates.SplashImageView
      backgroundImageSrc={splash}
      footerImageSrc={oftmcssLogo}
      splashContent={
        <Templates.SplashQuote
          quote={testimonial.quote}
          author={testimonial.author}
          title={testimonial.title}
          icon={
            <QuoteIcon
              style={{
                width: 'auto',
                height: '60px',
                display: 'block',
              }}
              className="fill-current text-white"
            />
          }
        />
      }
    >
      <Helmet>
        <title>Reset Your Password? - MCSS PRO Connect</title>
      </Helmet>
      <Content.Region>
        <Brand.EpcLogo />
        <Content.Heading>Reset Your Password</Content.Heading>
        <Forms.ResetPassword />
        <Content.List>
          <Content.ListItem>
            <Content.ListIcon>
              <FontAwesomeIcon icon={faQuestion} />
            </Content.ListIcon>
            <Content.Link to="/login/forgot">
              Need to send a new reset link?
            </Content.Link>
          </Content.ListItem>
        </Content.List>
      </Content.Region>
    </Templates.SplashImageView>
  )
}
